<div class="cf-dlg" [class.ctr-page]="!dialogRef">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>store</mat-icon></div>
    <div class="ctr-header-text">
      <h2 class="cf-dlg-title">{{ isEdit ? 'Editar centro' : 'Nuevo centro' }}</h2>
      <p class="cf-dlg-subtitle">{{ isEdit && center.name ? center.name : 'Datos del centro del contacto' }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="cancel()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" message="Cargando centro…"></app-loading-state>
  <app-loading-state *ngIf="ready && saving" message="Guardando centro…"></app-loading-state>

  <ng-container *ngIf="ready && !saving">
    <form class="ctr-form" (ngSubmit)="save()" novalidate>
      <div class="cf-dlg-body">
        <span class="cf-dlg-section__label">Datos generales</span>

        <div class="cf-dlg-row">
          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingName">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Nombre</mat-label>
              <input matInput name="name" [(ngModel)]="center.name" autocomplete="off" cdkFocusInitial>
            </mat-form-field>
            <div class="cf-field__error" *ngIf="submitted && missingName"><mat-icon>error</mat-icon> Indica el nombre del centro</div>
          </div>
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Código</mat-label>
            <input matInput name="code" [(ngModel)]="center.code" autocomplete="off">
          </mat-form-field>
        </div>

        <div class="cf-dlg-row">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Teléfono</mat-label>
            <input matInput type="tel" name="phone" [(ngModel)]="center.phone" autocomplete="off">
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Email</mat-label>
            <input matInput type="email" name="email" [(ngModel)]="center.email" autocomplete="off">
          </mat-form-field>
        </div>

        <span class="cf-dlg-section__label">Dirección</span>

        <div class="ctr-grid ctr-grid--address">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Dirección</mat-label>
            <input matInput name="address" [(ngModel)]="center.address" autocomplete="off">
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Código postal</mat-label>
            <input matInput name="postalCode" [(ngModel)]="center.postalCode" autocomplete="off">
          </mat-form-field>
        </div>

        <div class="cf-dlg-row">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Municipio</mat-label>
            <input matInput name="location" [(ngModel)]="center.location" autocomplete="off">
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Provincia</mat-label>
            <input matInput name="state" [(ngModel)]="center.state" autocomplete="off">
          </mat-form-field>
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>País</mat-label>
            <input matInput name="country" [(ngModel)]="center.country" autocomplete="off">
          </mat-form-field>
        </div>

        <ng-container *ngIf="showFaceFields">
          <span class="cf-dlg-section__label">Centros administrativos (FACe)</span>
          <p class="ctr-hint">Rellena los tres códigos DIR3 para facturar a la Administración Pública, o déjalos todos en blanco.</p>

          <div class="ctr-face" *ngFor="let block of faceBlocks">
            <div class="ctr-face__label">{{ block.label }}</div>
            <div class="ctr-grid ctr-grid--face">
              <div [class.cf-field--required]="faceUsed" [class.cf-field--invalid]="submitted && (missingFaceCode(block) || tooLongCode(block))">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Código</mat-label>
                  <input matInput [name]="block.key + 'Code'" [(ngModel)]="face[block.key].centreCode" [attr.maxlength]="faceCodeMax" autocomplete="off">
                </mat-form-field>
                <div class="cf-field__error" *ngIf="submitted && missingFaceCode(block)"><mat-icon>error</mat-icon> Indica el código</div>
                <div class="cf-field__error" *ngIf="submitted && tooLongCode(block)"><mat-icon>error</mat-icon> Máx. {{ faceCodeMax }} caracteres</div>
              </div>
              <div [class.cf-field--required]="faceUsed" [class.cf-field--invalid]="submitted && (missingFaceName(block) || tooLongName(block))">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Nombre</mat-label>
                  <input matInput [name]="block.key + 'Name'" [(ngModel)]="face[block.key].centreName" [attr.maxlength]="faceNameMax" autocomplete="off">
                </mat-form-field>
                <div class="cf-field__error" *ngIf="submitted && missingFaceName(block)"><mat-icon>error</mat-icon> Indica el nombre</div>
                <div class="cf-field__error" *ngIf="submitted && tooLongName(block)"><mat-icon>error</mat-icon> Máx. {{ faceNameMax }} caracteres</div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="cf-dlg-footer">
        <button type="button" mat-stroked-button class="cf-dlg-btn-secondary" (click)="cancel()">Cancelar</button>
        <button type="submit" mat-flat-button class="cf-dlg-btn-primary">
          <mat-icon>save</mat-icon> Guardar
        </button>
      </div>
    </form>
  </ng-container>
</div>
